import React from "react";
import DilatationMeter from "../ObSurveil/ObSurveilPatient/DilatationMeter";
import _ from "lodash";
import {
  ObPatientLocation,
  ObPatientStatus,
} from "../ObSurveil/ObSurveilPatient/ObPatientInfo";
import { MyPatientsToggle } from "./Patients";

export default function ObPatient({ patient, meta = {}, parent, appStore }) {
  const dilatation = meta.dilatation;

  return (
    <div
      className={parent.patientClass(patient)}
      key={patient.asmpid}
      onClick={() => parent.selectPatient(patient, "", "/ob-summary")}
    >
      <MyPatientsToggle
        patient={patient}
        parent={parent}
        appStore={appStore}
        ob={true}
      />
      <DilatationMeter dilatation={dilatation} />
      <div className="ob-meta">
        <div>{meta.physician}</div>
        <div>{meta.nurse}</div>
        <div>
          <ObPatientLocation bed={meta.location} />
        </div>
      </div>
      <div className="name">
        {patient.lastName}, {patient.firstName}
        <span className="info"> • {patient.age}</span>
      </div>
      <div className="info">
        {(_.get(
          parent.props.store.prefs,
          "userPreferences.client.pm.showPHI",
        ) === false
          ? null
          : patient.mrn) || "--"}{" "}
        | {meta.membraneStatus || "--"} | {meta.epiduralStatus || "--"}
      </div>
      <div className="info">
        <span>
          <ObPatientStatus specifics={meta} />
        </span>
      </div>
    </div>
  );
}
